export default __webpack_public_path__ + "static/media/BuckeyeLeaf-Active.48c08cbf.svg";